import React from "react";

import "./EventSignAction.scss";
import { useBeam } from "@randajan/bifrost/client/react";
import { eventBeam } from "../../../../assets/beams/eventBeam";
import { eventSignBeam } from "../../../../assets/beams/eventSignBeam";
import { EventSignIn } from "./EventSignIn/EventSignIn";
import { EventSignOut } from "./EventSignOut/EventSignOut";

export const EventSignAction = ({ eventId })=>{
    const { data:event } = useBeam(eventBeam, [eventId]);
    const signPort = useBeam(eventSignBeam, [eventId]);
    const { data:eventSign } = signPort;

    if (!event) { return null; }

    return (
        <div className="EventSignAction">
            {eventSign?.mySign
                ? <EventSignOut {...{ event, signPort }}/>
                : <EventSignIn {...{ event, signPort }}/>
            }
        </div>
    );
};